<clr-header>
  <div class="branding">
    <a routerLink="/" routerLinkActive="active" class="nav-link nav-text">
      <svg
        version="1.1"
        width="48"
        height="48"
        viewBox="0 0 36 36"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>GISGurus</title>
        <linearGradient
          id="KpzH_ttTMIjq8dhx1zD2pb"
          x1="2"
          x2="52"
          y1="5"
          y2="9.167"
          gradientUnits="userSpaceOnUse"
          spreadMethod="reflect"
        >
          <stop offset="0" stop-color="#1a6dff" />
          <stop offset="1" stop-color="#c822ff" />
        </linearGradient>
        <path
          fill="url(#KpzH_ttTMIjq8dhx1zD2pb)"
          d="M10.05,18a20.46,20.46,0,0,0,.62,4.93h6.48V13.45H10.58A20.55,20.55,0,0,0,10.05,18Z"
          class="clr-i-solid clr-i-solid-path-1"
        ></path>
        <path
          fill="url(#KpzH_ttTMIjq8dhx1zD2pb)"
          d="M18.85,13.45v9.48h6.48A20.46,20.46,0,0,0,26,18a20.55,20.55,0,0,0-.52-4.55Z"
          class="clr-i-solid clr-i-solid-path-2"
        ></path>
        <path
          fill="url(#KpzH_ttTMIjq8dhx1zD2pb)"
          d="M18,2A16,16,0,1,0,34,18,16,16,0,0,0,18,2ZM30.22,24.71H26.6a21.8,21.8,0,0,1-3,6,13.86,13.86,0,0,1-3,.92,20.21,20.21,0,0,0,4.18-6.94H18.86v7.15c-.29,0-.57,0-.86,0s-.55,0-.83,0V24.71H11.22a20.21,20.21,0,0,0,4.18,6.95,13.86,13.86,0,0,1-2.94-.9,21.8,21.8,0,0,1-3-6.05H5.78a13.94,13.94,0,0,1-.83-1.81h4A22.2,22.2,0,0,1,8.37,18a21.88,21.88,0,0,1,.48-4.55H4.76a13.88,13.88,0,0,1,.76-1.81H9.33A22.26,22.26,0,0,1,12.61,5a13.86,13.86,0,0,1,2.87-.84,20.13,20.13,0,0,0-4.4,7.45h6.09V4c.28,0,.55,0,.83,0s.58,0,.86,0v7.64h6.09a20.13,20.13,0,0,0-4.39-7.44A13.89,13.89,0,0,1,23.43,5a22.26,22.26,0,0,1,3.27,6.59h3.77a13.89,13.89,0,0,1,.76,1.81H27.17A21.88,21.88,0,0,1,27.66,18a22.2,22.2,0,0,1-.57,4.93h4A13.94,13.94,0,0,1,30.22,24.71Z"
          class="clr-i-solid clr-i-solid-path-3"
        ></path>
        <rect x="0" y="0" width="48" height="48" fill-opacity="0" />
      </svg>
      <span class="title"> <b>GISGurus</b></span>
    </a>
  </div>
  <div class="header-nav">
    <a
      clrVerticalNavLink
      class="nav-link nav-icon"
      routerLink="/spatial-toolkit"
      routerLinkActive="active"
      title="Geojson Editor"
    >
      <clr-icon shape="objects" class="is-solid" size="32"></clr-icon>
    </a>
  </div>
  <div class="spacer"></div>
  <div class="socialBrand">
    <div>
      <a
        aria-label="RaviShankar on Twitter"
        target="_blank"
        rel="noopener"
        href="https://twitter.com/ravioshankar"
        title="Twitter"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width="40px"
          height="40px"
        >
          <linearGradient
            id="7sJyQCZzdsESd~lp6E9tqa"
            x1="40"
            x2="40"
            y1="40"
            y2="40"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
          >
            <stop offset="0" stop-color="#6dc7ff" />
            <stop offset="1" stop-color="#e6abff" />
          </linearGradient>
          <path
            fill="url(#7sJyQCZzdsESd~lp6E9tqa)"
            d="M26.064,45.003c12.076,0,18.68-10.005,18.68-18.68c0-0.284-0.006-0.567-0.019-0.849 c1.282-0.927,2.396-2.083,3.275-3.399c-1.176,0.523-2.442,0.875-3.77,1.034c1.355-0.813,2.396-2.099,2.887-3.632 c-1.269,0.752-2.673,1.299-4.169,1.594c-1.198-1.276-2.904-2.074-4.792-2.074c-3.626,0-6.566,2.94-6.566,6.565 c0,0.515,0.058,1.016,0.17,1.497c-5.456-0.274-10.295-2.887-13.532-6.859c-0.564,0.97-0.889,2.097-0.889,3.3 c0,2.278,1.159,4.289,2.922,5.465c-1.077-0.033-2.089-0.329-2.974-0.821c-0.001,0.027-0.001,0.055-0.001,0.084 c0,3.18,2.263,5.834,5.267,6.436c-0.551,0.15-1.132,0.231-1.731,0.231c-0.423,0-0.834-0.042-1.234-0.118 c0.836,2.608,3.259,4.506,6.133,4.56c-2.247,1.761-5.078,2.81-8.154,2.81c-0.53,0-1.052-0.03-1.566-0.091 C18.906,43.916,22.356,45.003,26.064,45.003"
          />
          <linearGradient
            id="7sJyQCZzdsESd~lp6E9tqb"
            x1="32"
            x2="32"
            y1="5.25"
            y2="59.38"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
          >
            <stop offset="0" stop-color="#1a6dff" />
            <stop offset="1" stop-color="#c822ff" />
          </linearGradient>
          <path
            fill="url(#7sJyQCZzdsESd~lp6E9tqb)"
            d="M32,58C17.663,58,6,46.337,6,32S17.663,6,32,6s26,11.663,26,26S46.337,58,32,58z M32,8 C18.767,8,8,18.767,8,32s10.767,24,24,24s24-10.767,24-24S45.233,8,32,8z"
          />
        </svg>
      </a>
    </div>
    <div>
      <a
        aria-label="RaviShankar on Github"
        target="_blank"
        rel="noopener"
        href="https://github.com/ravioshankar"
        title="Github"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          width="40px"
          height="40px"
        >
          <linearGradient
            id="KpzH_ttTMIjq8dhx1zD2pa"
            x1="40"
            x2="40"
            y1="40"
            y2="40"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
          >
            <stop offset="0" stop-color="#6dc7ff" />
            <stop offset="1" stop-color="#e6abff" />
          </linearGradient>
          <path
            fill="url(#KpzH_ttTMIjq8dhx1zD2pa)"
            d="M25.008,56.007c-0.003-0.368-0.006-1.962-0.009-3.454l-0.003-1.55 c-6.729,0.915-8.358-3.78-8.376-3.83c-0.934-2.368-2.211-3.045-2.266-3.073l-0.124-0.072c-0.463-0.316-1.691-1.157-1.342-2.263 c0.315-0.997,1.536-1.1,2.091-1.082c3.074,0.215,4.63,2.978,4.694,3.095c1.569,2.689,3.964,2.411,5.509,1.844 c0.144-0.688,0.367-1.32,0.659-1.878C20.885,42.865,15.27,40.229,15.27,30.64c0-2.633,0.82-4.96,2.441-6.929 c-0.362-1.206-0.774-3.666,0.446-6.765l0.174-0.442l0.452-0.144c0.416-0.137,2.688-0.624,7.359,2.433 c1.928-0.494,3.969-0.749,6.074-0.759c2.115,0.01,4.158,0.265,6.09,0.759c4.667-3.058,6.934-2.565,7.351-2.433l0.451,0.145 l0.174,0.44c1.225,3.098,0.813,5.559,0.451,6.766c1.618,1.963,2.438,4.291,2.438,6.929c0,9.591-5.621,12.219-10.588,13.087 c0.563,1.065,0.868,2.402,0.868,3.878c0,1.683-0.007,7.204-0.015,8.402l-2-0.014c0.008-1.196,0.015-6.708,0.015-8.389 c0-2.442-0.943-3.522-1.35-3.874l-1.73-1.497l2.274-0.253c5.205-0.578,10.525-2.379,10.525-11.341c0-2.33-0.777-4.361-2.31-6.036 l-0.43-0.469l0.242-0.587c0.166-0.401,0.894-2.442-0.043-5.291c-0.758,0.045-2.568,0.402-5.584,2.447l-0.384,0.259l-0.445-0.123 c-1.863-0.518-3.938-0.796-6.001-0.806c-2.052,0.01-4.124,0.288-5.984,0.806l-0.445,0.123l-0.383-0.259 c-3.019-2.044-4.833-2.404-5.594-2.449c-0.935,2.851-0.206,4.892-0.04,5.293l0.242,0.587l-0.429,0.469 c-1.536,1.681-2.314,3.712-2.314,6.036c0,8.958,5.31,10.77,10.504,11.361l2.252,0.256l-1.708,1.49 c-0.372,0.325-1.03,1.112-1.254,2.727l-0.075,0.549l-0.506,0.227c-1.321,0.592-5.839,2.162-8.548-2.485 c-0.015-0.025-0.544-0.945-1.502-1.557c0.646,0.639,1.433,1.673,2.068,3.287c0.066,0.19,1.357,3.622,7.28,2.339l1.206-0.262 l0.012,3.978c0.003,1.487,0.006,3.076,0.009,3.444L25.008,56.007z"
          />
          <linearGradient
            id="KpzH_ttTMIjq8dhx1zD2pb"
            x1="32"
            x2="32"
            y1="5"
            y2="59.167"
            gradientUnits="userSpaceOnUse"
            spreadMethod="reflect"
          >
            <stop offset="0" stop-color="#1a6dff" />
            <stop offset="1" stop-color="#c822ff" />
          </linearGradient>
          <path
            fill="url(#KpzH_ttTMIjq8dhx1zD2pb)"
            d="M32,58C17.663,58,6,46.337,6,32S17.663,6,32,6s26,11.663,26,26S46.337,58,32,58z M32,8 C18.767,8,8,18.767,8,32s10.767,24,24,24s24-10.767,24-24S45.233,8,32,8z"
          />
        </svg>
      </a>
    </div>
  </div>
</clr-header>
